import dayjs from "dayjs";
import { JobAction } from "~/interface/Job";

export const useComputeDrawer = function () {
  const excute = (jobs:any, receipts:any, actualCash=0) => {
    let summary = {
          start: { amount: 0, timeText: '11:45 06/Oct', count:0 },
          deposit: { amount: 0, note: '', count:0 },
          withdraw: { amount: 0, count:0 },
          returned: { amount: 0, note: '', count:0 },         
          actualCash:{amount:actualCash, count:0}
      }
    
      const jobsDrawer = Object.values(jobs).filter((job)=> job.type == JobAction.DRAWER)
      const openDrawer = Object.values(jobs).filter((job)=> job.type == JobAction.OPEN_SHOP)
      const closeDrawer = Object.values(jobs).filter((job)=> job.type == JobAction.CLOSE_SHOP)
    
      //OPEN
      const newSummaryOpen = openDrawer.reduce((acc, job)=>{
        acc.start.amount = job.cashInitalAmount || 0
        acc.start.timeText = dayjs(job.timestamp).format("HH:mm DD/MM")
        acc.start.count += 1
        return acc
      }, summary)

      
    
    //DEPOSIT & WITHDRAW
      const newSummary = jobsDrawer.reduce((acc, job)=>{
        if(job.mode =="deposit"){
          acc.deposit.amount += job.amount || 0
          acc.deposit.count += 1
        }
        if(job.mode == "withdraw"){
          acc.withdraw.amount += job.amount || 0
          acc.withdraw.count += 1
        } 
        if(job.mode == "start"){
          acc.start.amount = job.cashInitalAmount || 0
          acc.start.count += 1
        } 
       
        return acc
      }, summary)
    
      //REFUND
      const voidBills = receipts.filter((r:any)=> isVoidedReceipt(r))
      const newSummaryVoid = voidBills.reduce((acc, receipt)=>{
        const cashAmount = getCashAmountFromReceipt(receipt)
        if(cashAmount > 0){
          acc.returned.amount += cashAmount
          acc.returned.count += 1
        }
        return acc
      }, summary)

      const goodBills = receipts.filter((r:any)=> !isVoidedReceipt(r))

      //return {amount:0, count:0}
      let cashPayment = computeCashPaymentWithReceipt(goodBills) || {amount:0, count:0}

      const drawerTotal = (summary.start.amount + summary.deposit.amount+ cashPayment.amount) - summary.withdraw.amount 
      const diff = summary.actualCash.amount  - drawerTotal
 
      summary = { ...newSummaryOpen, ...newSummary, ...newSummaryVoid, drawerTotal, diff, cashPayment}
    
    return summary
  }

  const computeCashPaymentWithReceipt = (receipts:any)=>{
      let paymentMap = {amount:0, count:0}
      receipts.forEach((receipt:any) => {
        const cashAmount = getCashAmountFromReceipt(receipt)
        if(cashAmount > 0){
          paymentMap.amount += cashAmount
          paymentMap.count += 1
        }
      })

      return paymentMap
  }

  const isVoidedReceipt = (receipt:any) => {
    return receipt?.IsDeleted === true || receipt?.voided === true || receipt?.status === "voided" || receipt?.billing?.voided === true
  }

  const getCashAmountFromReceipt = (receipt:any) => {
    const normalizedReceipt = receipt?._custom?.value || receipt
    const isCashType = (value:any) => String(value || "").trim().toLowerCase() === "cash"
    const toNumber = (value:any) => Number(value || 0) || 0
    const getPaymentTypeName = (payment:any) => payment?.type || payment?.name || payment?.paymentId
    const sumCashAmount = (payments:any[]) => {
      return payments.reduce((sum:number, payment:any) => {
        return isCashType(getPaymentTypeName(payment)) ? sum + toNumber(payment?.amount) : sum
      }, 0)
    }

    if (typeof normalizedReceipt?.PaymentType === "string") {
      const raw = normalizedReceipt.PaymentType.trim()

      if (raw.startsWith("[") && raw.endsWith("]")) {
        try {
          const parsed = JSON.parse(raw)
          if (Array.isArray(parsed) && parsed.length > 0) {
            return sumCashAmount(parsed)
          }
        } catch (_) {
          // Ignore parse error and continue fallback.
        }
      }

      if (isCashType(raw)) {
        return toNumber(normalizedReceipt?.GrandTotal)
      }
    }

    if (Array.isArray(normalizedReceipt?.multiplePayment) && normalizedReceipt.multiplePayment.length > 0) {
      return sumCashAmount(normalizedReceipt.multiplePayment)
    }

    if (Array.isArray(normalizedReceipt?.payment) && normalizedReceipt.payment.length > 0) {
      return sumCashAmount(normalizedReceipt.payment)
    }

    return 0
  }


  return {
    excute
  }  
  
};
